import {ScreenRegion} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/layout/Perspective';
import {Panel, PanelGroup} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/PanelState';
import {WSPIcon} from '@mintdata-wsp/resources/icons/WSPIcon';
import {WSPIcons, WSPIconSize} from '@mintdata-wsp/resources/icons/WSPIcons';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./PanelHeaderView.less');
const cx = classnames.bind(styles);

export interface PanelHeaderViewProps
{
    className?:string;
    group:PanelGroup;
    panel:Panel;
}

@observer
export class PanelHeaderView extends React.Component<PanelHeaderViewProps, any>
{
    @bind
    private _onTitleMouseDown(panel:Panel)
    {
        return (e:React.SyntheticEvent<any>)=>
                  {
                      const group = this.props.group;
                      const controller = controllers.ui.panels.general;

                      controller.selectPanel(panel.id);
                  };
    }

    @bind
    _onCloseClicked()
    {
        const {panel} = this.props;
        controllers.ui.panels.general.removePanel(panel);
    }

    render()
    {
        const {group,panel,className} = this.props;
        const header = panel.header;
        const iconElement:React.ReactElement<any> = header.icon;
        const hasIcon = iconElement?true:false;
        const headerTitle = header.title;
        const isCloseable = header.isCloseable;
        const controller = controllers.ui.panels.general;
        const isSelected = controller.isPanelSelectedAndActive(group, panel);
        const screenRegion = controller.findRegionOfPanel(panel);
        const isVertical = screenRegion === ScreenRegion.East || screenRegion === ScreenRegion.West;

        const title = typeof headerTitle === 'function'? headerTitle(): headerTitle;

        return  <div key={panel.id}
                     onMouseDown={this._onTitleMouseDown(panel)}
                     className={cx('panelHeader',
                                   {'hasIcon':hasIcon},
                                   {'selected':isSelected && !isVertical},
                                   {'selectedVertical':isSelected && isVertical},
                                   {'noCloseableButton':!isCloseable},
                                   className)}>
                        {
                            iconElement?
                                <div className={cx('iconHolder')}>
                                    {iconElement}
                                </div>
                                :
                                null
                        }
                        <div className={cx('titleText')}>
                            {title}
                        </div>
                        {
                            isCloseable?

                                <span onClick={this._onCloseClicked}>
                                    <WSPIcon className={cx('closeIcon')}
                                             name={WSPIcons.visualDesigner.panels.headers.ClosePanel}
                                             size={WSPIconSize.medium20} />
                                </span>
                                :
                                null
                        }

                </div>;
    }
}









